import script from "./Formulas.vue?vue&type=script&setup=true&lang=js"
export * from "./Formulas.vue?vue&type=script&setup=true&lang=js"

import "./Formulas.vue?vue&type=style&index=0&id=518661a3&lang=scss"

const __exports__ = script;

export default __exports__